module.exports = __webpack_public_path__ + "static/media/logo.5339c7f0.svg";